import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    inputId: String,
  };
  static targets = ["icon"];

  select() {
    const input = document.getElementById(this.inputIdValue);
    const iconId = this.iconTarget.dataset.iconId;
    const iconUrl = this.iconTarget.dataset.iconUrl;

    input.value = iconId;
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
    input.dispatchEvent(
      new CustomEvent("icon-library:selected", {
        bubbles: true,
        detail: { iconId, iconUrl },
      })
    );
    document.getElementById(`${this.inputIdValue}-link`).innerHTML = `
      <div class="flex items-center space-x-2">
        <div class="w-8 h-8">
          <img src="${iconUrl}" class="w-full h-full" />
        </div>
        <div class="flex items-center space-x-2">
          <span class="text-sm text-black">${this.iconTarget.dataset.iconName}</span>
        </div>
      </div>
    `;
    const clearBtn = document.getElementById(`${this.inputIdValue}-clear`);
    if (clearBtn) clearBtn.classList.remove("hidden");
    document.querySelector(".close-modal").click();
  }
}
